import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormHelperText from '@mui/material/FormHelperText';
import DialogTitle from '@mui/material/DialogTitle';
import useCustomTranslation from 'hooks/useCustomTranslation';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';

export default function FormDialog({ formOpen, setFormOpen, type, activities = null, activity, prices, onConfirm, formError, formSuccess }) {
  const { t } = useCustomTranslation();
  const [newName, setNewName] = React.useState(null);
  const [newPrice, setNewPrice] = React.useState(null);
  const [newActivity, setnewActivity] = React.useState(null);

  const handleClose = () => {
    setFormOpen(false);
    setNewName(null);
    setNewPrice(null);
    setnewActivity(null);
  };

  //merge
  const handleChange = (value) => {
    console.log(value);
    setNewName(value);
  };
  const handleNewChange = (value) => {
    console.log(value);
    setnewActivity(value);
  };
  const handleEditChange = (value) => {
    console.log(value);
    setNewName(value);
  };

  const handlePriceChange = (value) => {
    console.log(value);
    setNewPrice(value);
  };

  React.useEffect(() => {
    if (!formOpen) {
      return;
    }
    if (type === 'edit' && activity) {
      if (newName !== undefined && newName !== null) {
        console.log(newName);
      }
      // if activity has price_id
      console.log(activity.price_id);
      if (activity.price_id !== undefined || activity.price_id !== null) {
        const selectedPrice = prices.find(price => activity.price_id === price.id);

        setNewPrice(selectedPrice);
        console.log(selectedPrice);
      }
    } else if (type === 'merge' && activities?.length && newName) {
      console.log(newName)
      if (newName !== undefined && newName !== null) {
        console.log(newName);
      }
      // we need to see which activity is selected and then set the price
      // find which price has price_id from newName
      // first we select the activity, aka newName
      // then we get a price that 
      const selectedPrice = prices.find(price => newName.price_id === price.id);

      console.log(selectedPrice);
      setNewPrice(selectedPrice);
    }
  }, [type, activity, activities, newName, formOpen]);

  //for showing activity name in modal
  React.useEffect(() => {
    //if edit
    if (type === 'edit' && activity) {
      setNewName(activity.activity);
    }
    //TODO: formopen is not checked?
  }, [formOpen]);

  //this is triggered when modal is opened, we check if there is activity and type add
  React.useEffect(() => {
    if (type === 'add' && activity) {
      console.log(activity);
      setnewActivity(activity);
    }
  }, [type, activity]);



  return (
    <React.Fragment>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={formOpen}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            console.log(newName);
            console.log(newPrice);
            if (type === 'edit') {
              onConfirm(newName, newPrice);
            } else if (type === 'merge') {
              onConfirm(newName, newPrice);
            } else if (type === 'add') {
              onConfirm(newActivity, newPrice);
            }
            // onConfirm(newName);
            handleClose();
          },
        }}
      >
        <DialogTitle>{type == 'edit' ? t('Edit activity') : type == 'merge' ? t('Merge activities') : t('Add activity')}</DialogTitle>
        <DialogContentText p={3}>
          {type == 'edit' && (
            <>

              <Grid item mb={2}>
                <TextField
                  value={newName ?? ""}
                  onChange={(event) => handleEditChange(event.target.value)}
                  // onInputChange={(event, newValue) => handleEditChange(newValue)}
                  id="activity"
                  name="activity"
                  label={t("Activity name")}
                  type="text"
                  fullWidth
                  variant="standard"
                  autoFocus
                  required
                />
              </Grid>
            </>
          )}
          {type == 'add' && (
            <>

              <Grid item mb={2}>
                <TextField
                  value={typeof newActivity === 'string' ? newActivity : (newActivity?.activity ?? '')}
                  onChange={(event) => handleNewChange(event.target.value)}
                  // onInputChange={(event, newValue) => handleNewChange(newValue)}
                  id="activity"
                  name="activity"
                  label={t("Activity name")}
                  type="text"
                  fullWidth
                  variant="standard"
                  autoFocus
                  required
                />
              </Grid>
            </>
          )}
          {type == 'merge' && (
            <>
              <Grid item mb={2}>
                {t('To merge these activities:')} <strong>{activities.map(activity => activity.activity).join(', ')}</strong>;<br />
                {t('select a name or type a new one:')}

                <Autocomplete
                  id="merge"
                  name="merge"
                  freeSolo
                  value={newName ?? ""}
                  onChange={(event, newValue) => handleChange(newValue)}
                  onInputChange={(event, newValue) => handleChange(newValue)}
                  //TODO: for this would need a new function, because it will check by every keystroke,
                  // so if it's a new value, we need to convert it to an object
                  //rn we remove freesolo so you cant type a name... easier as well
                  //NB! take the fix from getOptionLabel in Clients autocomplete
                  getOptionLabel={(option) => {
                    // Handle both cases: option is an object or a string
                    if (typeof option === 'string') {
                      return option;
                    }
                    return option.activity || '';
                  }}
                  options={activities}
                  renderInput={(params) => <TextField {...params} label={t("Type an activity name")} />}
                />
              </Grid>
            </>
          )}
          <Autocomplete
            id="price"
            name="price"
            freeSolo
            value={newPrice ?? null}
            onChange={(event, newValue) => handlePriceChange(newValue)}
            // onInputChange={(event, newValue) => handlePriceChange(newValue)}
            //TODO: for this would need a new function, because it will check by every keystroke,
            // so if it's a new value, we need to convert it to an object
            //rn we remove freesolo so you cant type a name... easier as well
            //NB! take the fix from getOptionLabel in Clients autocomplete
            getOptionLabel={(option) => {
              // return option.type_of_service + ' ' + option.price || '';
              return option.price || '';
            }}
            options={prices}
            renderInput={(params) => <TextField {...params} label={t("Select price")} />}
          />
          {formError && <FormHelperText color="error">{formError}</FormHelperText>}
          {formSuccess && <FormHelperText color="">{formSuccess}</FormHelperText>}
        </DialogContentText>
        <DialogActions>
          <Button onClick={handleClose}>{t('Cancel')}</Button>
          <Button type="submit">{t('Confirm')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment >
  );
}
